import { AuthList } from "@/auth-list";


// Demo JWT secret - NOT FOR PRODUCTION USE

// Simple base64url encoding
function base64urlEncode(str: string): string {
  return btoa(str)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
}

// Generate a local JWT token for demo purposes
function generateDemoJWT(user: any): { accessToken: string; refreshToken: string } {
  const header = {
    alg: "HS256",
    typ: "JWT"
  };

  const now = Math.floor(Date.now() / 1000);
  const accessTokenPayload = {
    sub: user.id,
    email: user.email,
    name: user.name,
    role: user.role,
    iat: now,
    exp: now + (60 * 60) // 1 hour expiration
  };

  const refreshTokenPayload = {
    sub: user.id,
    email: user.email,
    iat: now,
    exp: now + (60 * 60 * 24 * 7) // 7 days expiration
  };

  // Create JWT: header.payload.signature (we'll skip real signature for demo)
  const accessToken = 
    base64urlEncode(JSON.stringify(header)) + '.' +
    base64urlEncode(JSON.stringify(accessTokenPayload)) + '.' +
    base64urlEncode('demo-signature');

  const refreshToken = 
    base64urlEncode(JSON.stringify(header)) + '.' +
    base64urlEncode(JSON.stringify(refreshTokenPayload)) + '.' +
    base64urlEncode('demo-signature');

  return { accessToken, refreshToken };
}

export async function loginAPI(username: string, password: string) {
  const user = AuthList.find(user => {
    const passwordMatch = user.password === password;
    const emailMatch = user.email === username;
    return emailMatch && passwordMatch;
  });
  
  if (!user) {
    console.log("No matching user found");
    throw new Error("Invalid credentials");
  }
  
  console.log("Login successful for:", user.email);
  
  // Generate JWT tokens
  const { accessToken, refreshToken } = generateDemoJWT(user);
  
  return {
    ...user,
    accessToken,
    refreshToken
  };
}

export async function refreshTokenAPI(refreshToken: string) {
  // For demo purposes, decode the refresh token and generate a new access token
  try {
    const parts = refreshToken.split('.');
    if (parts.length !== 3) throw new Error("Invalid token format");
    
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    
    // Check if refresh token is expired
    const now = Math.floor(Date.now() / 1000);
    if (payload.exp < now) {
      throw new Error("Refresh token expired");
    }
    
    // Find user and generate new tokens
    const user = AuthList.find(u => u.email === payload.email);
    if (!user) throw new Error("User not found");
    
    const { accessToken, refreshToken: newRefreshToken } = generateDemoJWT(user);
    
    return {
      accessToken,
      refreshToken: newRefreshToken,
      user
    };
  } catch (error) {
    throw new Error("Token refresh failed");
  }
}
